import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./NotifyModal.css";
import Cross from "../../../../../../assets/images/Vector.png";
import axios from "axios";
import swal from "sweetalert";
import { io } from "socket.io-client";
import { serverInfo } from "../../../../../../App";

export default function NotifyModalAdmin(props) {
  const [notificationText, SetNotificationText] = useState("");
  const socket = useRef();
  const { shoketUrl } = useContext(serverInfo);
  /**
   * socket connection
   */

  useEffect(() => {
    socket.current = io(shoketUrl);
  }, []);
  const HandelNotificationSent = () => {
    const Data = new FormData();
    Data.append("users", props.users_id);
    Data.append("msg", notificationText);
    Data.append("greetings_id", props.greetings_reg_id);
    Data.append("greeting_id", props.greeting_id);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post("api/admin/sent_notofiaction_user", Data).then((res) => {
        if (res.data.status === 200) {
          // start send notification by socket here
          socket.current.emit("greetings_user", {
            greetingsRegId: props.greetings_reg_id,
            usersId: props.users_id,
          });
          socket.current.emit("refreshNotificationPhone", {
            id: 1,
          });
          // end send notification by socket here
          props.setChecked([]);
          props.setGreetingList(res.data.list);
          swal("Success", "Notification Sent Successfully !", "success");
        }
      });
    });
    props.setModalShowl(false);
  };

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter w-100 "
        centered
      >
        <Modal.Body className="NotifyBGModal ">
          <button className="RightSlotBtn closeButton" onClick={props.onHide}>
            <img src={Cross} alt="" className="NotImgMo" />
          </button>
          <br />
          <div className="ModalHeadNo text-warning mb-2">
            Notification message
          </div>
          <div className=" moNotifyAd">
            <div className="form-group row text-light mb-2 p-3">
              <textarea
                name="sms_body"
                className="sms-body"
                id=""
                cols="20"
                rows="5"
                onChange={(e) => SetNotificationText(e.target.value)}
              ></textarea>
            </div>
            <div className="NotifyMobtn">
              <button
                className="btn btn-warning"
                onClick={HandelNotificationSent}
              >
                Send
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
